module.exports = __webpack_public_path__ + "img/mark.86260b7b.gif";